import { FileSearchOutlined } from '@ant-design/icons';
import { css, cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import { ScreenBreakpoint, Spacing, TextAlign } from 'src/styles';

import { ClientServicesLink } from '../ClientServicesLink/ClientServicesLink';
import { MTypography } from '../MTypography/MTypography';

const rowStyle = css`
  width: 60%;
  margin: 0 auto;

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    width: 80%;
  }
`;

interface NotFoundErrorContentProps {
  title?: string;
  goTo?: {
    label: string;
    path: string;
  };
  className?: string;
}

export const NotFoundErrorContent = ({
  title = "Oops! The page you're looking for isn't found",
  goTo = { label: 'Home', path: '/' },
  className,
}: NotFoundErrorContentProps = {}) => {
  return (
    <Row className={cx(rowStyle, className)}>
      <Col span={24} className={cx(Spacing.my32, TextAlign.center)}>
        <FileSearchOutlined style={{ fontSize: 72 }} />
      </Col>
      <Col span={24} className={Spacing.my16}>
        <MTypography variant='h5' weight='semibold'>
          {title}
        </MTypography>
      </Col>
      <Col span={24} className={Spacing.my16}>
        <MTypography variant='h5' weight='semibold'>
          What you can do:
        </MTypography>
        <ul>
          <li className={Spacing.my8}>
            <MTypography variant='h5' weight='semibold' key='go-to'>
              Go to <Link to={goTo.path}>{goTo.label} page</Link>
            </MTypography>
          </li>
          <li className={Spacing.my8}>
            <MTypography variant='h5' weight='semibold' key='check-url'>
              Check your URL again or navigate using the main menu
            </MTypography>
          </li>
        </ul>
      </Col>
      <Col span={24} className={Spacing.my16}>
        <MTypography variant='h5' weight='semibold'>
          Need assistance? Please contact <ClientServicesLink />
        </MTypography>
      </Col>
    </Row>
  );
};
